/*
  Ananyoo accessibility fixes - Icons Miami Eyewear (Prestige theme)
  M/S. Anblik - Phase 1 - October 2026
  1. Search suggestions: announce how many results are shown (WCAG 4.1.3 Status Messages)
  2. Add to cart: announce the total number of items in the cart (WCAG 4.1.3 Status Messages)
  3. Cart icon: screen reader name includes the item count
  Uses the theme's own hidden status region (#status-announcement).
*/
(function () {
  'use strict';

  function getRegion() {
    return document.getElementById('status-announcement');
  }

  function announce(message, delay) {
    var region = getRegion();
    if (!region || !message) return;
    region.textContent = '';
    setTimeout(function () { region.textContent = message; }, delay || 150);
  }

  function itemsText(count) {
    return count === 1 ? '1 item' : count + ' items';
  }

  /* 1. Search suggestions */
  var searchTimer;
  function announceSearch(container) {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      var form = document.getElementById('predictive-search-form');
      var input = form ? form.querySelector('input[name="q"]') : null;
      var query = input ? input.value.trim() : '';
      if (!query) return;
      var products = new Set();
      var collections = new Set();
      container.querySelectorAll('a[href*="/products/"]').forEach(function (a) { products.add(a.pathname); });
      container.querySelectorAll('a[href*="/collections/"]').forEach(function (a) { collections.add(a.pathname); });
      var parts = [];
      if (products.size) parts.push(products.size + (products.size === 1 ? ' product' : ' products'));
      if (collections.size) parts.push(collections.size + (collections.size === 1 ? ' collection' : ' collections'));
      var message = parts.length ? parts.join(' and ') + ' found for ' + query + '.' : 'No results found for ' + query + '.';
      announce(message, 150);
    }, 600);
  }

  function watchSearch() {
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      var slot = ps.querySelector('[slot="results"]');
      if (!slot || slot.getAttribute('data-anx-watched')) return;
      slot.setAttribute('data-anx-watched', '1');
      new MutationObserver(function () {
        if (slot.children.length) announceSearch(slot);
      }).observe(slot, { childList: true });
    });
  }

  /* 2. Add to cart: add the cart total to the theme's own message */
  var strings = window.themeVariables && window.themeVariables.strings;
  var baseAdded = strings ? strings.addedToCartWithTitle : null;
  var lastAdd = 0;

  document.addEventListener('variant:add', function (event) {
    var cart = event.detail && event.detail.cart;
    if (strings && baseAdded && cart) {
      strings.addedToCartWithTitle = baseAdded + ' Your cart now has ' + itemsText(cart.item_count) + '.';
    }
  }, true);

  document.addEventListener('variant:add', function (event) {
    var now = Date.now();
    if (now - lastAdd < 1000) return;
    lastAdd = now;
    var detail = event.detail || {};
    var cart = detail.cart;
    if (!cart) return;
    setTimeout(function () {
      var region = getRegion();
      if (region && region.textContent.indexOf('Your cart now has') !== -1) return;
      var titles = (detail.items || []).map(function (item) { return item && item.title; }).filter(Boolean);
      var added = titles.length ? titles.join(', ') + ' added to cart.' : 'Item added to cart.';
      announce(added + ' Your cart now has ' + itemsText(cart.item_count) + '.', 50);
    }, 450);
  });

  /* 3. Cart icon name with item count */
  function updateCartLabels(count) {
    if (typeof count !== 'number') return;
    document.querySelectorAll('a[aria-controls="cart-drawer"] .sr-only').forEach(function (span) {
      if (!span.getAttribute('data-anx-base')) span.setAttribute('data-anx-base', span.textContent.trim() || 'Cart');
      span.textContent = span.getAttribute('data-anx-base') + ', ' + itemsText(count);
    });
  }

  /* Cart icon opens the cart drawer, so expose it as a button (Space key also opens it) */
  function enhanceCartButtons() {
    document.querySelectorAll('a[aria-controls="cart-drawer"]').forEach(function (link) {
      if (link.getAttribute('data-anx-button')) return;
      link.setAttribute('data-anx-button', '1');
      link.setAttribute('role', 'button');
      link.addEventListener('keydown', function (event) {
        if (event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          link.click();
        }
      });
    });
  }

  function refreshCartCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) { updateCartLabels(cart.item_count); })
      .catch(function () {});
  }

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.cart) updateCartLabels(event.detail.cart.item_count);
  });
  document.addEventListener('cart:refresh', refreshCartCount);

  function init() {
    watchSearch();
    enhanceCartButtons();
    refreshCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
